
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Hikaye',
	'noDashboardFound': 'Hikaye alınamıyor. Artık yok veya görüntülemek için yeterli izniniz yok.',
	'noDashboardCapability': 'Hikayeleri kullanma yeteneğiniz yok',
	'noDashboardPermision': 'Bu hikayeyi görüntülemek için yeterli ayrıcalıklarınız yok',
	'defaultName': 'Yeni hikaye',
	'storyProperties': 'Hikaye özellikleri',
	'createAvDataStoryLabel': 'Hikaye',
	'createAvSlideShowLabel': 'Slayt Gösterisi',
	'createAvPanAndZoomLabel': 'Kılavuzlu yolculuk',
	'dashboard_save_success': 'Hikayeniz kaydedildi.',
	'cmEmptySelection': 'Hikaye silindi. Yeni bir hikaye kaydetmeyi deneyin.',
	'createStoryTitle': 'Bir hikaye oluştur',
	'transitionStyleTitle': 'Geçiş Stili',
	'createButton': 'Oluştur',
	'cancelButton': 'İptal',
	'dashboardResetTitle': 'Hikayeyi sıfırla',
	'dashboardResetMessage': 'Bu hikayeye uygulanan tüm değişiklikleri sıfırlamak istediğinizden emin misiniz?',
	'dashboardResetToast': 'Hikayeniz sıfırlandı.',
	'filter_drag_and_drop_all_tabs': 'Tüm sahnelere süzgeç uygulamak için verileri buraya sürükleyip bırakın.',
	'filter_drag_and_drop_current_tab': 'Bu sahneye süzgeç uygulamak için verileri buraya sürükleyip bırakın.',
	'filterIconLabel_Global': 'Tüm sahneler',
	'filterIconLabel_Tab': 'Bu sahne',
	'filterIconTooltip_Global': 'Tüm sahneler',
	'filterIconTooltip_Tab': 'Bu sahne',
	'filterOverflowMenu_Global': 'Tüm sahneler için taşma menüsü',
	'filterOverflowMenu_Tab': 'Bu sahne için taşma menüsü',
	'renameScene': 'Sahneyi yeniden adlandır',
	'duplicateScene': 'Sahneyi çoğalt',
	'deleteScene': 'Sahneyi sil',
	'editTimelineHighlight': 'Vurguyu düzenle',
	'deleteTimelineHighlight': 'Vurguyu sil',
	'filter_includesAll': 'Tümünü içerir',
	'timeline_highlight_moved_to': 'Zaman çizelgesi vurgusu %{id}, %{time} hedefine taşındı',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Seç',
	'newDefaultStoryName': 'Hikaye: %{modelName}',
	'exportLabel': 'Kaydet',
	'exportAsLabel': 'Farklı kaydet:',
	'exportDialogTitle': 'Hikaye olarak kaydet',
	'exportDialogFooter': 'Kaydet ve iptal düğmeleri',
	'loadAfterExportLabel': 'Kaydettikten sonra hikayeyi aç',
	'selectTemplateLabel': 'Bir şablon seçin',
	'outOfBoundsWarningMessage': 'Bazı gösterge panosu pencere öğeleri ızgaranın dışındadır ve dışa aktarıldıktan sonra düzgün görüntülenmeyebilir.',
	'emptyExploreCardsWarningMessage': 'Hikaye olarak kaydetme sırasında boş kartlar silindi.',
	'dashboard_export_success': 'Gösterge panonuz bir hikaye olarak başarıyla kaydedildi.',
	'explore_export_success': 'Keşfiniz bir hikaye olarak başarıyla kaydedildi.',
	'toastUpgradeDone': 'Hikayeniz yükseltildi. En iyi performansı korumak için şimdi kaydedin.',
	'navigationMarker': 'Dolaşma işaretçisi',
	'navigateMarkers': 'İşaretçiler arasında dolaş',
	'navNextMarker': 'Sonraki işaretçi',
	'navPrevMarker': 'Önceki işaretçi',
	'navPrevMarkerAbbreviated': 'Önceki işaretçi',
	'timelineSettingsButton': 'Kayıttan yürütme seçenekleri',
	'autoPlay': 'Tüm sahneleri oynat',
	'loop': 'Döngü',
	'refreshData': 'Başlangıçta yenile',
	'slideshowLabel': 'Slayt gösterisi',
	'panAndZoomLabel': 'Kılavuzlu yolculuk',
	'slideShowLayoutLabel': 'Slayt gösterisi düzeni',
	'panAndZoomLayoutLabel': 'Kılavuzlu yolculuk düzeni',
	'panAndZoomLayoutFooter': 'Kılavuzlu yolculuk düzeni, tek bir tuvaldeki sahneler derlemidir. Bu tip hikayeyi çalıştırdığınızda sunum her bir sahneyi sırayla yakınlaştırır ve yatay kaydırır. Bu, her bir sahnenin yeni bir tuvalde sunulduğu slayt gösterisi düzeninden farklıdır. Çizgilerle bağlanmış üç sahne içeren kılavuzlu yolculuk düzeni, yatay sahne sırası oluşturmanıza olanak sağlar. Bu bir zaman çizelgesini göstermek için yararlıdır.',
	'PanAndZoomLayout1': '5 sahne dikdörtgen şeklinde düzenlendi',
	'PanAndZoomLayout2': '4 sahne soldan sağa doğru merdiven şeklinde düzenlendi',
	'PanAndZoomLayout3': '6 sahne dikdörtgen şeklinde düzenlendi',
	'PanAndZoomLayout4': '7 sahne; üstte 6 küçük sahne ve altta 1 büyük sahne olacak biçimde dikdörtgen şeklinde düzenlendi',
	'PanAndZoomLayout5': '3 sahne; üstte 2 küçük sahne ve altta 1 büyük sahne olacak biçimde düzenlendi',
	'PanAndZoomLayout6': 'Sıralı 4 sahne yatay olarak ayarlandı',
	'pageSelectWarning': 'Lütfen bir sahne seçin.',
	'noSceneTransitionLabel': 'Yok',
	'sceneTransitionPropertyLabel': 'Sahne geçişi',
	'animatedPathSceneTransitionLabel': 'Animasyonlu yol',
	'sweepSceneTransitionLabel': 'Tarama',
	'storyTypeLabel': 'Hikaye tipi',
	'layoutLabel': 'Düzen',
	'tabName_animation': 'Animasyon',
	'propAniAnimation': 'Animasyon',
	'propAniTypeEntrance': 'Giriş animasyonu',
	'propAniDirectionIn': 'Giriş yönü',
	'propAniTypeExit': 'Çıkış animasyonu',
	'propAniDirectionOut': 'Çıkış yönü',
	'propAniDirection': 'Yön',
	'propAniEntrance': 'Giriş',
	'propAniTypeEntranceSlideIn': 'Kaydırarak gir',
	'propAniTypeEntranceFadeIn': 'Belirme',
	'propAniTypeEntrancePivotIn': 'Merkeze alma',
	'propAniTypeEntranceScaleIn': 'Ölçeklendir',
	'propAniTypeEntranceShrinkIn': 'Daralt',
	'propAniDirectionInLeft': 'Soldan',
	'propAniDirectionInRight': 'Sağdan',
	'propAniDirectionInTop': 'Üstten',
	'propAniDirectionInBottom': 'Alttan',
	'propAniExit': 'Çıkış',
	'propAniTypeExitSlideIn': 'Kaydırarak çık',
	'propAniTypeExitFadeIn': 'Silinme',
	'propAniTypeExitPivotOut': 'Merkezden çıkarma',
	'propAniTypeExitScaleIn': 'Ölçeği genişletme',
	'propAniTypeExitExpandOut': 'Genişlet',
	'propAniDirectionOutLeft': 'Sola',
	'propAniDirectionOutRight': 'Sağa',
	'propAniDirectionOutTop': 'Üste',
	'propAniDirectionOutBottom': 'Alta',
	'propAniEntranceTime': 'Başlangıç (saniye):',
	'propAniExitTime': 'Bitiş (saniye):',
	'animationNoEntranceText': 'Pencere bileşeni, sahnenin başındaysa giriş animasyonu oluşmaz.',
	'animationNoExitText': 'Pencere bileşeni, sahnenin sonundaysa çıkış animasyonu oluşmaz.',
	'propAniTypeDataEntrance': 'Veri girişi',
	'propAniRevealDuration': 'Animasyon süresini girin',
	'timelineAnimationProperties': 'Animasyon özelliklerini aç',
	'scenesPropertiesSection': 'Sahneler',
	'editStoryCoachMarkTitle': 'Hikayeyi düzenle',
	'editStoryCoachMarkContents': 'Bu hikayeyi düzenlemek için kalem simgesini tıklatın.',
	'addDataStoryCoachMarkContents': 'Veri panosundan hikayenize verileri sürükleyip bırakın.',
	'expandSceneCoachmarkTitle': 'Zaman çizelgesini aç',
	'expandSceneCoachmarkContents': 'Zaman ve süreye göre nesne görünürlüğünü ayarlayarak bir sahne canlandırın.',
	'overviewCoachmarkTitle': 'Genel bakış sahneleri',
	'overviewCoachmarkContents': 'Tüm sahnelerin büyük resmini göstermek için hikayenizin başında ve sonunda genel bakış sahnelerini kullanın. Bir sahneyi başka bir sahneyle değiştirmek için genel bakış sahnesinde ilgili sahneyi tıklatın ve sürükleyin. Hikaye özelliklerinde genel bakış sahnelerini gösterebilir veya gizleyebilirsiniz.',
	'animatedPathCoachmarkTitle': 'Animasyonlu yol',
	'animatedPathCoachmarkContents': 'Bir sahneden diğerine doğru nesneye animasyon uygulamak için nesne içeren bir sahneyi çoğaltın. Ardından yeni sahnede çoğaltılan nesneyi taşıyın, yeniden boyutlandırın ya da döndürün.',
	'propShowStoryOverviewFirstSlide': 'Başlangıçta tüm sahneleri göster',
	'propShowStoryOverviewLastSlide': 'Sonunda tüm sahneleri göster',
	'storySceneSingleCountLabel': '1 sahne',
	'storySceneCountLabel': '%{count} sahne',
	'storySceneRangeCountLabel': 'Sahne %{index} / %{count}',
	'storySceneExpand': 'Zaman çizelgesini aç',
	'storySceneActionMenu': 'Sahne seçenekleri menüsünü başlat',
	'timelineRightContainerLabel': 'Zaman çizelgesi düğme denetim grubu',
	'timelineViewLabel': 'Zaman çizelgesi',
	'timelineZoomFit': 'Sığdırmak için yakınlaştır',
	'timelineZoomIn': 'Yakınlaştır',
	'timelineZoomOut': 'Uzaklaştır',
	'timelinePositionIndicator': '%{position} konumundaki zaman çizelgesi konum göstergesi',
	'timelinePositionIndicatorMoveLeftTo': 'zaman çizelgesi konum göstergesini soldaki %{position} konumuna taşı',
	'timelinePositionIndicatorMoveRightTo': 'zaman çizelgesi konum göstergesini sağdaki %{position} konumuna taşı',
	'sceneStart': '%{position} konumundaki sahnenin başına atla',
	'sceneEnd': '%{position} konumundaki sahnenin sonuna atla',
	'timelineHighlightTitle': 'Vurgu',
	'addTimelineHighlight': 'Vurgu ekle',
	'addSceneBtnTitle': 'Varsayılan şablon ile yeni bir sahne ekle',
	'addSceneChevronBtnTitle': 'Bir sahne şablonu seçin',
	'timelinePlay': 'Yürüt',
	'timelinePause': 'Duraklat',
	'sceneNavigation': 'Sahnede dolaşma',
	'navNextScene': 'Sonraki sahne',
	'navPrevScene': 'Önceki sahne',
	'navPrevSceneAbbreviated': 'Önceki sahne',
	'navExitFullScreen': 'Tam ekrandan çık',
	'navToggleOverview': 'Genel bakışı aç/kapat',
	'rowNumber': 'Satır %{number}',
	'overviewBtnLabel': 'Genel bakış',
	'sceneListStart': 'Genel bakış başlangıcı',
	'sceneListEnd': 'Genel bakış sonu',
	'timelineLeftHandle': '%{name} için sol tutamaç',
	'timelineRightHandle': '%{name} için sağ tutamaç',
	'timelineLeftHandleNoTitle': 'sol tutamaç',
	'timelineRightHandleNoTitle': 'sağ tutamaç',
	'timelineMoveLeft': '%{object} nesnesini sola taşı',
	'timelineMoveRight': '%{object} nesnesini sağa taşı',
	'timelineMoveWidget': 'zaman çizelgesi pencere öğesi, %{newStartTime} ve %{newEndTime} hedefine taşındı',
	'timelineMoveWidgetStartTime': 'zaman çizelgesi pencere öğesi başlangıç zamanı, %{newStartTime} olarak değişti',
	'timelineMoveWidgetEndTime': 'zaman çizelgesi pencere öğesi bitiş zamanı, %{newEndTime} olarak değişti',
	'timelineMoveWidgetDown': 'zaman çizelgesi pencere öğesi aşağı taşındı',
	'timelineMoveWidgetUp': 'zaman çizelgesi pencere öğesi yukarı taşındı',
	'addSceneTitle': 'Sahne ekle',
	'blankSceneLayout': 'Boş',
	'titleSceneLayout': 'Alt başlık içeren başlık',
	'sceneLayout1': 'Bir görselleştirmenin yanında metin içeren başlık',
	'sceneLayout2': 'Bir görselleştirme içeren başlık',
	'sceneLayout3': 'İki görselleştirme içeren başlık',
	'sceneLayout4': 'Çok amaçlı',
	'sceneLayout5': 'Bir görselleştirmenin yanında metin içeren başlık yok',
	'sceneLayout6': 'Çok amaçlı 2 x 2',
	'sceneLayout7': 'Çok amaçlı 1 yanında 2',
	'sceneLayout8': 'Çok amaçlı 2 yanında 1',
	'sceneLayout9': 'Çok amaçlı 2 üzerinde 1',
	'sceneLayout10': 'Çok amaçlı 1 üzerinde 2',
	'sceneLayout11': 'Çok amaçlı 1 üzerinde 4',
	'sceneLayout12': 'Çok amaçlı 1 üzerinde 2 x 2\'in yanında 1 üzerinde 1',
	'titleWidgetPlaceholderText': 'Başlığınızı buraya girin',
	'subtitleWidgetPlaceholderText': 'Alt başlığınızı buraya girin',
	'createStoryViewTitle': 'Hikaye oluştur',
	'defaultStoryName': 'Yeni hikaye',
	'screenshot_label': 'Hikaye %{title}',
	'screenshot_label_scene': 'Sahne %{sceneTitle} / hikaye %{title}',
	'filmstripHandleOpenLabel': 'Sahne seçiciyi aç',
	'filmstripHandleCloseLabel': 'Sahne seçiciyi kapat'
});
